import api from "utils/axiosInstance";
import URL from "./apiURL";


export async function updateHolidaysList(payload) {
  try {
    const res = await api.post(URL.updateHolidaysList, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error updating the holidays list:", error);
    throw error;
  }
}
